import api from ".";

const deletedFile = async (idFichier: string) => {
  const res = await api.delete("/fichier/" + idFichier);
};
export { deletedFile };
